import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectBedroomsFilter } from 'shared/selectors/advancedFilters';

export const BedroomsContainer: FC = () => {
  const { label, value, options } = useSelector(selectBedroomsFilter);

  const onChange = useFilterChangeCallback();

  const handleBedroomsCountChange = useCallback(
    (newValue: number | null) => {
      onChange(
        { action: 'setBedroomsCountMin', arguments: [newValue] },
        { action: 'setBedroomsCountMax', arguments: [null] },
      );
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter options={options} value={value} onFilterChange={handleBedroomsCountChange} />
    </AdvancedFilterRow>
  );
};
